import { getSearch } from '../offices/offices-selectors';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import { api, BASE_URL, showErrorNotification, showSuccessNotification } from '@med-fe/util';

import {
  LOAD_TABS_REQUEST,
  loadTabsSuccess,
  loadTabsFailure,
  SUBMIT_EXPORT_REQUEST,
  submitExportSuccess,
  submitExportFailure,
  closeTabsExport,
  OPEN_TABS_EXPORT,
} from './export-actions';
import { getTabsExportState } from './export-selectors';
import { HrPartnersEnum } from '../collapsible-panel/hr-partners.enum';

// Load tabs when dialog opens
function* onOpen() {
  yield put({ type: LOAD_TABS_REQUEST });
}

function* loadTabsWorker(): Generator {
  try {
    const data: any = yield call(api.get, '/import/tabs');
    // The backend always adds the HRTOD column to HR exports (it identifies each row), so it is not user-selectable.
    if (Array.isArray(data?.HR)) {
      data.HR = data.HR.filter((label: string) => label !== HrPartnersEnum.HRTOD);
    }
    yield put(loadTabsSuccess(data));
  } catch (e) {
    yield put(loadTabsFailure((e as any)?.message || 'Error loading tabs'));
    showErrorNotification('Failed to load tabs data', e);
  }
}

function* submitExportWorker(): Generator {
  console.log('Saga: submitExport called');
  try {
    const maxSize = 100000; // according to BE implementation
    const state: ReturnType<typeof getTabsExportState> = yield select(getTabsExportState);
    const tabs: Record<string, string[]> = {};
    const existingData = state.toggleValue === 'Existing';
    const search = yield select(getSearch);

    for (const [tab, set] of Object.entries(state.selected)) {
      if (set && (set as Set<string>).size > 0) {
        tabs[tab] = Array.from(set as Set<string>);
      }
    }

    const payload = {
      tabs,
      existingData,
      searchDTO: search,
    };

    // yield call(api.post, , payload);
    yield call(api.downloadFile, '/import/export', {
      ...payload,
      page: 0,
      size: maxSize,
      type: 'xlsx',
    });

    showSuccessNotification('Export request submitted successfully');
    yield put(submitExportSuccess());
    yield put(closeTabsExport());
  } catch (e) {
    yield put(submitExportFailure((e as any)?.message || 'Error submitting export request'));
    showErrorNotification('Failed to submit export request', e);
  }
}

export function* tabsExportSaga() {
  yield takeLatest(OPEN_TABS_EXPORT, onOpen);
  yield takeLatest(LOAD_TABS_REQUEST, loadTabsWorker);
  yield takeLatest(SUBMIT_EXPORT_REQUEST, submitExportWorker);
}
